import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PrivatePerson} from '../../model/private-person.model';
import {CustomerService} from '../../../core/services/customer.service';
import {INewPrivatePerson} from '../../model/interface/new-private-person.model.interface';
import {LegalEntityType} from '../../model/legal-entity.model';

@Component({
  selector: 'app-add-private-person',
  templateUrl: './add-private-person.component.html',
  styleUrls: ['./add-private-person.component.css']
})
export class AddPrivatePersonComponent implements OnInit {
  requiredContact = false;
  instructing: number;

  constructor(private dialogRef: MatDialogRef<AddPrivatePersonComponent>,
              private customerService: CustomerService,
              @Inject(MAT_DIALOG_DATA) data) {
    this.requiredContact = data?.requiredContact ?? data?.requiredContract ?? false;
    this.instructing = typeof data === 'number' ? data : data?.lessorId;
  }

  ngOnInit(): void {
  }

  add(formValue) {
    const mainAddress = formValue.mainAddress;
    const correspondenceAddress = formValue.correspondenceAddress;
    const addresses = [];

    if (mainAddress) {
      mainAddress.typeId = 1;
      addresses.push(mainAddress)
    }

    if (correspondenceAddress?.city) {
      correspondenceAddress.typeId = 2;
      addresses.push(correspondenceAddress)
    }

    const newPrivatePerson: INewPrivatePerson = {
      name: formValue.name,
      pesel: formValue.pesel,
      type: LegalEntityType.NATURAL_PERSON,
      surname: formValue.surname,
      secondName: formValue.secondName,
      addresses,
      individualNumber: formValue.individualNumber
    };

    return this.customerService.createPrivatePerson(newPrivatePerson, this.instructing).subscribe(
      (person) => {
        this.close(person);
      }
    );
  }

  cancel() {
    this.close(null);
  }

  private close(value: PrivatePerson | null) {
    this.dialogRef.close(value);
  }
}
